import { Icon, IconsEnum } from 'components/Icons';
import styles from './IlMioSaldoEmptyState.module.scss';

export type IlMioSaldoEmptyStateProps = {
  myProp?: string;
};

export const IlMioSaldoEmptyState = ({ myProp }: IlMioSaldoEmptyStateProps) => {
  return (
    <p className={styles.container}>
      <span className={styles.iconContainer}>
        <Icon className={styles.icon} iconId={IconsEnum.INFO_SOLID} color="var(--color-on-bg-secondary)" />
      </span>
      <span className={styles.text}>Il tuo saldo Bonus cash è vuoto.</span>
      <span className={styles.text}>Guarda tutte le Promo e scopri subito come ottenerlo!</span>
    </p>
  );
};
